<div class="categorization-view offset-adjustment-view">
    <h3 class="offset-adjustment-title">Offset Adjustment</h3>
    <p class="offset-adjustment-subheader">Insert a manual adjustment plus an inverted offset item.</p>

    <div class="offset-adjustment-field offset-adjustment-manual-item">
        <span class="offset-adjustment-field-label">
            <strong>Manual Item Categorization:</strong> {{ manualItemLabel }}
        </span>
    </div>

    <div class="offset-adjustment-field offset-adjustment-search">
        <label class="offset-adjustment-field-label dropdown-select-label">Offset Adjustment Categorization</label>
        <div class="offset-dropdown" [class.offset-dropdown--open]="isDropdownOpen">
            <button
                #dropdownTrigger
                type="button"
                class="offset-dropdown-trigger"
                [class.offset-dropdown-trigger--placeholder]="!selectedOffsetItem"
                (click)="toggleDropdown()"
            >
                <span class="offset-dropdown-trigger-text">{{ triggerLabel }}</span>
                <i class="fas offset-dropdown-trigger-chevron"
                   [ngClass]="isDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
                   aria-hidden="true"></i>
            </button>
            <div
                class="offset-dropdown-panel"
                *ngIf="isDropdownOpen && dropdownPosition"
                [style.top.px]="dropdownPosition.top"
                [style.left.px]="dropdownPosition.left"
                [style.width.px]="dropdownPosition.width"
            >
                <app-template-item-search-select
                    [state]="state"
                    [excludeItemId]="row?.lineItemId ?? null"
                    [selectedItemId]="selectedOffsetItemId"
                    placeholder="Search line items..."
                    (itemSelected)="onOffsetItemSelected($event)"
                ></app-template-item-search-select>
            </div>
        </div>
    </div>

    <div class="offset-adjustment-actions">
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="!selectedOffsetItem"
            (click)="onInsertItems()"
        >Insert item(s)</button>
    </div>
</div>
